import React, { useState } from 'react';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    company: '',
    email: '',
    phoneNumber: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await fetch('/api/submit-form', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Failed to submit form');
      }

      setShowSuccess(true);
      setFormData({
        firstName: '',
        lastName: '',
        company: '',
        email: '',
        phoneNumber: '',
      });
    } catch (error) {
      console.error('Form submission error:', error);
      alert('Failed to submit the form. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="bg-background py-16 md:py-24 px-6 md:px-10 border-t border-slate-200/60">
      {showSuccess && (
        <div className="fixed inset-0 bg-accent/50 z-50 flex items-center justify-center p-6">
          <div className="bg-background border border-slate-200/60 p-8 max-w-md w-full rounded-lg">
            <div className="text-center">
              <div className="mb-4">
                <div className="w-12 h-12 bg-accent rounded-full mx-auto flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              </div>
              <h3 className="text-xl font-semibold text-text-primary mb-2">Thank You</h3>
              <p className="text-base text-text-secondary mb-6 leading-7">
                We've received your information and will contact you shortly to schedule a call.
              </p>
              <button
                onClick={() => setShowSuccess(false)}
                className="bg-accent text-white px-6 py-2 text-base font-medium hover:opacity-90 transition-opacity"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="max-w-6xl mx-auto">
        <div className="mb-12">
          <p className="text-xs font-medium tracking-widest uppercase text-text-secondary mb-3">Get In Touch</p>
          <h2 className="text-2xl md:text-3xl font-semibold text-text-primary mb-6">Contact</h2>
          <p className="text-base text-text-secondary max-w-2xl leading-7">
            Drop your contact info and we'll shoot you an email to book a call and learn more about your business.
          </p>
        </div>

        <div className="max-w-2xl">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  First Name
                </label>
                <input
                  required
                  type="text"
                  id="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="w-full bg-background border border-slate-200/60 px-4 py-3 text-text-primary text-base focus:outline-none focus:border-accent transition-colors rounded"
                  placeholder="John"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  Last Name
                </label>
                <input
                  required
                  type="text"
                  id="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  className="w-full bg-background border border-slate-200/60 px-4 py-3 text-text-primary text-base focus:outline-none focus:border-accent transition-colors rounded"
                  placeholder="Doe"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-text-secondary mb-2">
                Company
              </label>
              <input
                required
                type="text"
                id="company"
                value={formData.company}
                onChange={handleChange}
                className="w-full bg-background border border-slate-200/60 px-4 py-3 text-text-primary text-base focus:outline-none focus:border-accent transition-colors rounded"
                placeholder="Your Company"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-text-secondary mb-2">
                Email
              </label>
              <input
                required
                type="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full bg-background border border-slate-200/60 px-4 py-3 text-text-primary text-base focus:outline-none focus:border-accent transition-colors rounded"
                placeholder="john@example.com"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-text-secondary mb-2">
                Phone Number
              </label>
              <input
                required
                type="tel"
                id="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                className="w-full bg-background border border-slate-200/60 px-4 py-3 text-text-primary text-base focus:outline-none focus:border-accent transition-colors rounded"
                placeholder="(123) 456-7890"
              />
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className={`w-full ${
                isSubmitting 
                  ? 'bg-accent/50 cursor-not-allowed' 
                  : 'bg-accent hover:opacity-90'
              } text-white py-4 text-base font-medium transition-opacity rounded`}
            >
              {isSubmitting ? 'Submitting...' : 'Book a Call'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
